import React, { useState } from 'react';
import '../../styles/GardenWallNode.css';
import NoConnection from '../GardenWall/NoConnection';
import Dashboard from '../GardenWall/GardenWallApp';
import TemporaryDisconnectBase from '../GardenWall/TemporaryDisconnectBase';
import { FaRegCircleXmark } from 'react-icons/fa6';
import { Snackbar, Alert } from '@mui/material';
import { PAYMENT_SCENARIOS } from '../GardenWall/Constants/paymentScenarios';
import { COMPANY_CONFIG } from '../../constants/companyConfig';
import homepageDefault from '../../assets/icons/homepage.png';
import homepageArchtop from '../../assets/icons/homepage-archtop.png';
import homepageHighline from '../../assets/icons/homepage-highline.png';
import homepageAcs from '../../assets/icons/homepage-acs.png';
import homepagecwf from '../../assets/icons/homepage-cwf.png';


const COMPONENT_MAP = {
  NoConnection: NoConnection,
  Dashboard: Dashboard,
  TemporaryDisconnectBase: TemporaryDisconnectBase,
};

const GardenWallNode = ({ status }) => {
  const [activeData, setActiveData] = useState(null);
  const [activeComponent, setActiveComponent] = useState(null);

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('error');

  // Get homepage image from company config
  const getHomepageImage = () => {
    const configPath = COMPANY_CONFIG?.ui?.gardenwallhomepageImage;
    if (configPath?.includes('homepage-archtop')) {
      return homepageArchtop;
    } else if (configPath?.includes('homepage-highline')) {
      return homepageHighline;
    }else if (configPath?.includes('homepage-acs')) {
      return homepageAcs;
    }else if (configPath?.includes('homepage-cwf')) {
      return homepagecwf;
    }
    return homepageDefault;
  };

  const homepageImage = getHomepageImage();
 // console.log(homepageImage, 'homepageImage');
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCardClick = (component, data) => {
    if (!status) {
      setSnackbarOpen(false);
      setActiveData(data);
      setActiveComponent(component);
      console.log('GardenWallNode - Setting activeData:', data);
    } else {
      setSnackbarOpen(true);
      setSnackbarMessage('Please save the workflow');
    }
  };

  if (activeComponent) {
    const Component = COMPONENT_MAP[activeComponent];
    console.log(
      'GardenWallNode - Rendering component:',
      activeComponent,
      'with data:',
      activeData
    );
    return (
      <div className="dynamic-component">
        <Component activeData={activeData} />
        <button
          className="back-button"
          onClick={() => setActiveComponent(null)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          >
            <path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path>
          </svg>
        </button>
      </div>
    );
  }

  return (
    <>
      <div
        className="garden-wall-node"
        style={{ '--homepage-image': `url(${homepageImage})` }}
      >
        <div className="dashboard-container">
          {/* Service Disconnected Card */}
          {/*<div 
            className="dashboard-card clickable-card"
            onClick={() => handleCardClick('NoConnection', PAYMENT_SCENARIOS.SERVICE_DISCONNECTED)}
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.SERVICE_DISCONNECTED.title}</h2>
              <p>{PAYMENT_SCENARIOS.SERVICE_DISCONNECTED.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup">
                <div className="mockup-content">
                  <div className="icon-container">
                    <span className="icon no-wifi"></span>
                  </div>
                  <div className="mockup-text">
                    <h3>Your service is temporarily disconnected</h3>
                    <p>We regret to inform you that your internet connection has been temporarily disconnected due to an overdue payment.</p>
                    <button className="primary-button-preview">Make a Payment Now!</button>
                    <div className="secondary-buttons-preview">
                      <button className="secondary-button-preview">View Invoice</button>
                      <button className="secondary-button-preview">Contact Us</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="test-workflow-button">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>
              </svg>
              Test Workflow
            </div>
          </div>*/}

          <div
            className="dashboard-card db clickable-card"
            onClick={() =>
              handleCardClick(
                'TemporaryDisconnectBase',
                PAYMENT_SCENARIOS.SERVICE_DISCONNECTED
              )
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.SERVICE_DISCONNECTED.title}</h2>
              <p>{PAYMENT_SCENARIOS.SERVICE_DISCONNECTED.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup">
                <div className="mockup-content">
                  <div className="icon-container">
                    <span className="icon no-wifi"></span>
                  </div>
                  <div className="mockup-text">
                    <h3>Your service is temporarily disconnected</h3>
                    <p>
                      We regret to inform you that your internet connection has
                      been temporarily disconnected due to an overdue payment.
                    </p>
                    <button className="primary-button-preview">
                      Make a Payment Now!
                    </button>
                    <div className="secondary-buttons-preview">
                      <button className="secondary-button-preview">
                        View Invoice
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>

          {/* GardenWall Card */}
          <div
            className="dashboard-card db clickable-card"
            onClick={() =>
              handleCardClick('Dashboard', PAYMENT_SCENARIOS.GARDENWALL)
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.GARDENWALL.title}</h2>
              <p>{PAYMENT_SCENARIOS.GARDENWALL.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup dashboard-mockup">
                {/* Dashboard preview content */}
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>

          {/* Payment Not Received on Due Date Card */}
          <div
            className="dashboard-card db clickable-card card-hide"
            onClick={() =>
              handleCardClick('Dashboard', PAYMENT_SCENARIOS.DUE_DATE)
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.DUE_DATE.title}</h2>
              <p>{PAYMENT_SCENARIOS.DUE_DATE.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup dashboard-mockup">
                {/* Dashboard preview content */}
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>

          {/* Over 30 Days Past Due Card */}
          <div
            className="dashboard-card db clickable-card card-hide"
            onClick={() =>
              handleCardClick('Dashboard', PAYMENT_SCENARIOS.OVERDUE_30)
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.OVERDUE_30.title}</h2>
              <p>{PAYMENT_SCENARIOS.OVERDUE_30.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup dashboard-mockup">
                {/* Dashboard preview content */}
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>

          {/* Over 60 Days Past Due Card */}
          <div
            className="dashboard-card db clickable-card card-hide"
            onClick={() =>
              handleCardClick('Dashboard', PAYMENT_SCENARIOS.OVERDUE_60)
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.OVERDUE_60.title}</h2>
              <p>{PAYMENT_SCENARIOS.OVERDUE_60.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup dashboard-mockup">
                {/* Dashboard preview content */}
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>

          {/* Over 90 Days Past Due Card */}
          <div
            className="dashboard-card db clickable-card card-hide"
            onClick={() =>
              handleCardClick('Dashboard', PAYMENT_SCENARIOS.OVERDUE_90)
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.OVERDUE_90.title}</h2>
              <p>{PAYMENT_SCENARIOS.OVERDUE_90.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup dashboard-mockup">
                {/* Dashboard preview content */}
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>

          {/* Over 120 Days Past Due Card */}
          <div
            className="dashboard-card db clickable-card card-hide"
            onClick={() =>
              handleCardClick('Dashboard', PAYMENT_SCENARIOS.OVERDUE_120)
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.OVERDUE_120.title}</h2>
              <p>{PAYMENT_SCENARIOS.OVERDUE_120.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup dashboard-mockup">
                {/* Dashboard preview content */}
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>

          {/* Over 150 Days Past Due Card */}
          <div
            className="dashboard-card db clickable-card card-hide"
            onClick={() =>
              handleCardClick('Dashboard', PAYMENT_SCENARIOS.OVERDUE_150)
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.OVERDUE_150.title}</h2>
              <p>{PAYMENT_SCENARIOS.OVERDUE_150.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup dashboard-mockup">
                {/* Dashboard preview content */}
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>

          {/* Over 180 Days Past Due Card */}
          <div
            className="dashboard-card db clickable-card card-hide"
            onClick={() =>
              handleCardClick('Dashboard', PAYMENT_SCENARIOS.OVERDUE_180)
            }
          >
            <div className="card-header">
              <h2>{PAYMENT_SCENARIOS.OVERDUE_180.title}</h2>
              <p>{PAYMENT_SCENARIOS.OVERDUE_180.description}</p>
            </div>
            <div className="card-preview">
              <div className="preview-mockup dashboard-mockup">
                {/* Dashboard preview content */}
              </div>
            </div>
            <div className="test-workflow-button">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 5V19L19 12L8 5Z" fill="currentColor" />
              </svg>
              Test Workflow
            </div>
          </div>
        </div>
      </div>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default GardenWallNode;
